import { fetchUsers } from 'utils/fetchUsers'

const getUserCountForMixpanel = async (accountKey) => {
  const AND = encodeURIComponent('&')
  const OR = encodeURIComponent('|')

  const getUsersCount = await fetchUsers({
    filters: {
      filter: `(((adminRoles eq "")))${AND}(((status eq "ACTIVE"))|((status eq "INACTIVE"))|((status eq "INVITED")))${OR}(((status eq "ACTIVE")))`,
      pageSize: 1,
    },
    lmiAccountKey: accountKey,
  })

  return (await getUsersCount()).total
}
export default getUserCountForMixpanel
